/* globals dataLayer, optimizely */

import $ from 'jquery';
import _ from 'underscore';
import cookies from '../twig/helpers/cookies';

const mktoSteps = {

  setHash(step, steps) {
    if (step < (steps + 1)) {
      location.hash = `step-${step}`;
    } else {
      location.hash = 'complete';
    }
  },

  setFieldsets(step, fieldsets, nonProgessiveFields) {
    if (!fieldsets[step - 1]) return;
    _.each(fieldsets, (fieldset) => {
      fieldset.style.display = 'none';
    });
    fieldsets[step - 1].style.display = 'block';

    const mktoFormRow = fieldsets[step - 1].getElementsByClassName('mktoFormRow');
    _.each(mktoFormRow, (val, i, list) => {
      const selectFirst = val.getElementsByTagName('select')[0];
      if (!_.isUndefined(selectFirst)) {
        const isProgressiveField = () => nonProgessiveFields === null || nonProgessiveFields.indexOf(selectFirst.getAttribute('id')) === -1;
        const isFirstFieldSet = () => typeof list[i-1].getElementsByTagName('select')[0] === 'undefined' || list[i-1].getElementsByTagName('select')[0].value === '';

        if (i !== 0 && isProgressiveField() && isFirstFieldSet()) {
          mktoFormRow[i].style.display = 'none';
        } else {
          mktoFormRow[i].style.display = 'block';
        }
      }
    });
  },

  setOptions(step, fieldsets, target) {
    if (step > 1) return;
    const select = $(fieldsets[step - 1]).find('select');
    const options = $(select[1]).find('option:enabled');
    let formArray = [];

    switch (select[0].value) {
      case 'Restaurant / Bar':
        formArray = [
          'Drinking Place',
          'Full Service Restaurant',
          'Other',
        ];
        break;
      case 'Retail':
        formArray = [
          'Clothing / Accessories',
          'Consignment Store',
          'Gift Shop',
          'Grocery / Convenience Store',
          'Hotel',
          'Pet Services',
          'Recreation / Entertainment',
          'Salon / Barber Shop',
          'Shoe Store',
          'Specialty Food',
          'Specialty Retail',
          'Specialty Services',
          'Vape Shop',
          'Wine / Liquor / Beer',
          'Other',
        ];
        break;
      case 'Quick-Serve':
        formArray = [
          'Bakery',
          'Coffee Shop',
          'Concessions / Snacks',
          'Food Truck',
          'Ice Cream / Yogurt',
          'Juice Bar',
          'Limited-Service Restaurant',
          'Other',
        ];
        break;
      default:
        formArray = [];
    }

    if (window.location.pathname === '/perfect-pos-solution') {
      formArray.pop();
    }

    if (window.location.pathname === '/perfect-ipad-pos') {
      formArray.pop();
    }

    if (target === select[1]) {
      return;
    }

    if (!_.contains(this.stepsWithEvents, step)) {
      $(select[0]).on('change', () => {
        select[1].value = '';
      });
    }

    if (formArray.length) {
      options.remove();
      _.each(formArray, (val) => {
        $(select[1]).append(`<option value="${val}">${val}</option>`);
      });
    }
  },

  inputChange(step, fieldsets, prefix, gaPrefix) {
    if (!fieldsets[step - 1]) return;
    const mktoFormRow = fieldsets[step - 1].querySelectorAll('.mktoFormRow');
    const selects = fieldsets[step - 1].querySelectorAll('select');
    const inputs = fieldsets[step - 1].querySelectorAll('input');
    const currentPOS = fieldsets[step - 1].querySelectorAll('select')[1];
    let mktoError;

    _.each(selects, (select) => {
      select.addEventListener('change', (selected) => {
        const target = selected.target;
        const formAction = 'Select';
        const fieldValue = target.value;
        const fieldName = target.parentNode.querySelector('label').innerText.replace(/[^a-zA-Z ]/g, '');
        const formStep = step;
        const gaEvent = gaPrefix ? `${gaPrefix}PSG` : 'PSG';

        dataLayer.push({ event: gaEvent, formAction, fieldName, fieldValue, formStep });


        const navUserAgent = navigator.userAgent.toLowerCase();

        if (navUserAgent.indexOf('safari') > -1 && navUserAgent.indexOf('chrome') === -1) {
          window.scrollTo(0, window.pageYOffset + 1);
        }

        cookies.setMarketoFields(target.id, fieldValue);

        if (target.id === 'Years_in_Business__c' && fieldValue === 'Not open yet') {
          currentPOS.value = 'None';
          cookies.setMarketoFields('Has_POS_System_Currently__c', 'None');
          dataLayer.push({ event: gaEvent, formAction, fieldName: 'Current POS System', fieldValue: 'None', formStep });
        } else if (!_.isUndefined(mktoFormRow[1])) {
          mktoFormRow[1].style.display = 'block';
        }


        if (target.id === 'Business_Category__c') {
          mktoSteps.setOptions.call(this, step, fieldsets, selected.currentTarget);
        }
      });

      select.addEventListener('click', () => {
        mktoError = document.querySelectorAll('.mktoError');
        mktoError = _.toArray(mktoError);
        if (!_.isEmpty(mktoError)) {
          mktoError[0].remove();
        }
      });
    });

    _.each(inputs, (input) => {
      input.addEventListener('input', () => {
        mktoError = document.querySelectorAll('.mktoError');
        mktoError = _.toArray(mktoError);
        if (!_.isEmpty(mktoError)) {
          mktoError[0].remove();
        }
      });
    });
  },

  inputIsInvalid(parentElement, form) {
    const inputs = parentElement.querySelectorAll('select, input:not([type="hidden"])');
    const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+[^.]\.[A-Z]{2,}$/i;
    const phoneRegEx = /^1?[(. \t-]*[0-9]{3}[)+. \t-]*[0-9]{3}[+. \t-]*[0-9]{4}(?:\s?[a-zA-Z]{1,10}[\s-.+]?[0-9()]{1,6})?$/;
    
    const isInvalid = !_.every(inputs, (inputElem) => {
      const elemTag = inputElem.tagName.toLowerCase();
      const elemType = inputElem.type.toLowerCase();
      const formElem = form.getFormElem().find(`#${inputElem.id}`);

      if (elemTag === 'select' || (elemTag === 'input' && elemType === 'text')) {
        if (inputElem.value === '') {
          form.showErrorMessage('This field is required.', formElem);
          return false;
        }
      }

      if (elemTag === 'input' && elemType === 'email' && !emailRegEx.test(inputElem.value)) {
        form.showErrorMessage('Must be valid email. example@yourdomain.com', formElem);
        return false;
      }

      if (elemTag === 'input' && (elemType === 'tel' || elemType === 'phone') && !phoneRegEx.test(inputElem.value)) {
        form.showErrorMessage('Must be a US or Canadian phone number.<br>503-555-1212 x2343', formElem);
        return false;
      }

      return true;
    });

    return isInvalid;
  },

  setTextChange(step, steps, button, stepsText, cta, id) {
    button.text('Next');
    let headerWrapper = document.getElementsByClassName('mktoHeader');

    const formPresent = !_.every(headerWrapper, (val, index) => {
      const form = val.parentElement.querySelectorAll('.mktoHeader ~ * form, .mktoHeader ~ form')[0];
      if (!form) {
        return true;
      }
      const formId = form.id;
      if (formId.indexOf(id) > -1) {
        headerWrapper = headerWrapper[index];
        return false;
      }

      return true;
    });


    if (formPresent) {
      const header = headerWrapper ? headerWrapper.querySelector('h2,h5') : '';
      const subheader = headerWrapper ? headerWrapper.querySelector('p') : '';

      _.each(stepsText, (val, key) => {
        if (key === (`step${step}`)) {
          if (val.markup) {
            headerWrapper.innerHTML = val.markup;
          }

          if (val.header) {
            header.textContent = val.header;
          }

          if (val.subheader) {
            subheader.textContent = val.subheader;
          }

          if (val.button) {
            button.text(val.button);
          }

          if (key === (`step${steps}`)) {
            button.text(cta);
          }

          if (val.afterMarkup) {
            $('.mktoHeader + form').after(`<div class="mkto-after-markup">${val.afterMarkup}</div>`);
          }
        }
      });
    }
  },
};

export default mktoSteps;
